import { render, staticRenderFns } from "./addChangeOfficial.vue?vue&type=template&id=c963f13c&scoped=true&"
import script from "./addChangeOfficial.vue?vue&type=script&lang=js&"
export * from "./addChangeOfficial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c963f13c",
  null
  
)

export default component.exports